/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Slip_Qr_LabelInputs */

const vi_delivery_slip_qr_label = /** @type {(inputs: Delivery_Slip_Qr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quét để xác nhận đã giao xong`)
};

/**

* @param {Delivery_Slip_Qr_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const delivery_slip_qr_label = /** @type {((inputs?: Delivery_Slip_Qr_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Slip_Qr_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_delivery_slip_qr_label(inputs)
});